module.exports = __webpack_public_path__ + "static/transparency-hotspot-f41c1acaca77d222b623662d432b2ca2.mp4";